'use client'
import {
  usePopper
} from "./chunk-LUYFNC5G.mjs";
import "./chunk-P4KPSAOW.mjs";
import "./chunk-AUJXXV3B.mjs";
import {
  cssVars
} from "./chunk-6WT2JRWX.mjs";
export {
  cssVars as popperCSSVars,
  usePopper
};
//# sourceMappingURL=index.mjs.map